<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
</script>

<template>
    <div class="text-gray-l-500 text-0.5sm">
        <p>{{ usePoolStore().getDescription }}</p>
    </div>
</template>
